var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPropertyIcon = function SvgPropertyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.885 14.77V6.154a.614.614 0 0 0 .338-1.126L8.845.107a.5.5 0 0 0-.22-.105 1 1 0 0 0-.118 0 1 1 0 0 0-.117 0 .5.5 0 0 0-.22.093L.79 5.017a.615.615 0 0 0 .338 1.138v8.614a.615.615 0 1 0 0 1.231h14.756a.615.615 0 0 0 0-1.23M2.36 5.465l6.148-4.11 6.149 4.11v9.304h-3.69v-4.308a.615.615 0 0 0-.614-.615h-3.69a.614.614 0 0 0-.614.615v4.307h-3.69V5.466m7.378 9.303h-2.46v-3.691h2.46z"
  })));
};
export { SvgPropertyIcon as ReactComponent };